import React from 'react';
import {Route} from 'react-router-dom';
import getModal from 'config/navigation/util/get-modal';
import {ModalRouteProps} from '..';

const getModalRoute: React.FC<ModalRouteProps> = ({
  path,
  element,
  permissions,
  title,
  noLayout,
  size,
  centered,
  withCloseButton,
}) => (
  <Route
    key={path}
    {...{
      path,
      element: noLayout
        ? element
        : getModal({
            element,
            permissions,
            title,
            size,
            centered,
            withCloseButton,
          }),
    }}
  />
);

export default getModalRoute;
